module.exports = __webpack_public_path__ + "5ea24d6bb41953bdfe076cbfd33454e8.svg";